import React, { Component } from 'react';
import { Container, Row, Col, CardBody, Button } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import PrintIcon from '@material-ui/icons/Print';
import labReport from './LabPdf';


class Laboratorio extends Component {
    constructor(props) {
        super(props);

        this.state = {
            results: '',
            notes: '',
        }
    }

    componentDidMount() {
        //console.log(this.props);
    }

    handlerResults = (results) => {
        this.setState({ results: results });
    }

    handlerNotes = (notes) => {
        this.setState({ notes: notes });
    }

    genertePdf = () => {

        const data = {
            patient: this.props.patient,
            professional: this.props.professional,
            clinic: this.props.clinic,
            results: this.state.results !== "" ? this.state.results : this.props.examResults.results,
            notes: this.state.notes !== "" ? this.state.notes : this.props.examResults.notes,
        }

        labReport(data);
    }

    render() {

        return (
            <CardBody>
                <div className="form" style={{ flex: 1, flexDirection: 'column' }}>
                    <div className="card__title">
                        <h5 className="bold-text">Procedimiento Laboratorio</h5>
                    </div>

                    <div style={{ flexDirection: 'row', display: 'flex' }}>
                        <div className="form__form-group">
                            <span className="form__form-group-label">Resultados: </span>
                            <div className="form__form-group-field">

                                <textarea
                                    name="textarea-results-labs"
                                    defaultValue={this.props.examResults.results}
                                    onChange={(e) => { this.handlerResults(e.target.value) }}
                                >
                                </textarea>
                            </div>
                        </div>
                        <div className="form__form-group" style={{ marginLeft: 15 }}>
                            <span className="form__form-group-label">Notas: </span>
                            <div className="form__form-group-field">
                                <textarea
                                    name="textarea-notes-labs"
                                    defaultValue={this.props.examResults.notes}
                                    onChange={(e) => { this.handlerNotes(e.target.value) }}
                                >
                                </textarea>

                            </div>
                        </div>
                    </div>
                    <div className="form__form-group">
                        {this.state.profile === "12" || this.state.profile === "4" ?
                            (<Button
                                style={{ marginTop: 20 }}
                                variant="contained"
                                color="primary"
                                disabled={this.props.isCloseClinicHistory}
                                onClick={() => {
                                    //this.saveProcedure();
                                }}
                            > Guardar Procedimieto
                            </Button>) : null
                        }
                        <Button
                            style={{ marginTop: 20, marginLeft: 20 }}
                            variant="contained"
                            color="primary"
                            startIcon={<PrintIcon />}
                            onClick={() => {
                                this.genertePdf();
                            }}
                        > Imprimir
                        </Button>
                    </div>
                </div>
            </CardBody>);
    }
}

export default reduxForm({
    form: 'procedureslab_form', // a unique identifier for this form
})(Laboratorio);